import React from 'react';
import { useViewport } from '~/utils/viewport-provider';

interface PartialTextProps {
  block: {
    _template: string;
    list_columns?: string;
    title_font_size?: number;
    text_font_size?: number;
    title: string;
    icon?: string;
    text: string;
  };
  image?: string;
  image_alt_text?: string;
}

const PartialText = ({ block, image, image_alt_text }: PartialTextProps) => {
  const { isDesktop } = useViewport();
  return (
    <section
      className={`partial ${block._template} ${block.list_columns === '1' ? 'cols-1' : ''}`}
    >
      {block.title && (
        <h3
          style={{
            display: block.icon ? `flex` : '',
            fontSize:
              block.title_font_size && isDesktop
                ? `${block.title_font_size}rem`
                : '',
            lineHeight:
              block.title_font_size && isDesktop
                ? `${block.title_font_size + 1}rem`
                : '',
          }}
        >
          {block.icon && (
            <img
              src={block.icon}
              alt={block.title}
              title={block.title}
            />
          )}
          <span dangerouslySetInnerHTML={{ __html: block.title }}></span>
        </h3>
      )}
      {image && block.title && (
        <img
          className='card-image is-mobile'
          src={image}
          alt={image_alt_text}
          title={image_alt_text}
        />
      )}
      {block.text && (
        <div
          className='text-formatted'
          style={{
            fontSize:
              block.text_font_size && isDesktop
                ? `${block.text_font_size}rem`
                : '',
            lineHeight:
              block.text_font_size && isDesktop
                ? `${block.text_font_size + 1}rem`
                : '',
          }}
          dangerouslySetInnerHTML={{ __html: block.text }}
        ></div>
      )}
    </section>
  );
};

export default PartialText;
